module.exports = __webpack_public_path__ + "images/emoji/smoking.24349e8954f6bcf190ef.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smoking.png
// module id = 1tk9
// module chunks = 13